import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

export const Wrapper = styled.section`
  padding: 48px 0 32px;
  background-color: var(--white);

  @media (min-width: ${getBreakpoint('xl')}px) {
    background: linear-gradient(
      0deg,
      var(--vila-olimpia-10) 51%,
      var(--white) 49%
    );
    padding: 96px 0 56px;
  }
`

export const Title = styled.p`
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 29px;
  color: var(--primary-text);
  margin: 0;

  @media (min-width: ${getBreakpoint('xl')}px) {
    text-align: center;
    font-size: 40px;
    line-height: 48px;
  }
`

export const Subtitle = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: var(--secondary-text);
  margin: 8px 0 0;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 4px 0 0;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
  }
`

export const CardWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  max-width: 936px;
  margin-top: 32px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 60px;
  }
`

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  background: var(--white);
  border: 1px solid var(--vila-olimpia-30);
  border-radius: 16px;
  margin-bottom: 24px;
  width: 100%;
  height: 385px;
  box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease-out;

  &:hover {
    transform: scale(1.08);
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 288px;
    margin-right: 24px;
    margin-bottom: 0;
  }
`

export const CardIcon = styled(Image)`
  width: 80px;
  height: 80px;
`

export const CardTitle = styled.p`
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  color: var(--primary-text);
  margin: 8px 0 0;
`

export const CardSubtitle = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: var(--primary-text);
  margin: 8px 0 0;
`

export const PriceWrapper = styled.section`
  margin: 32px 0 18px;
`

export const Price = styled.p`
  display: flex;
  align-items: baseline;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  margin: 0;
  color: var(--secondary-text);

  span {
    font-weight: 900;
    font-size: 48px;
    line-height: 58px;
    margin: 0 8px;
    color: var(--primary-text);
  }
`

export const PriceDescription = styled.p`
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  color: var(--primary-text);
  margin: 56px 0 44px;
`

export const Body1 = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-text);
  margin: 8px 0 0;
  text-align: center;

  @media (min-width: ${getBreakpoint('xl')}px) {
    font-size: 18px;
    line-height: 24px;
    margin-top: 40px;
  }
`

export const LargeCompaniesLink = styled.a`
  width: 100%;
`

export const PriceTitle = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: var(--primary-text);
  margin: 0;
  text-align: center;
`
